<template>
    <div>
        <section class="main-slider" v-if="softwareInfo">
            <div class="page-header-bg" >
            </div>
            <div class="container">
                <div class="page-header__inner">
                   <img  :src="softwareInfo.title_img" />
                    <div style="font-size: var(--font-size-30);font-weight: 700;color: var(--notech-white)">{{ softwareInfo.title_en }}</div>
                </div>
            </div>
        </section>
            
		<section class="main_title" v-if="softwareInfo">
            <div class=" container">
                <div class="row">
                    <div class="col-xl-12 col-lg-12" >
                        <div class="main_content">
                            <div class="title">
                                <!-- {{ softwareInfo.title }} -->
                                {{  $t(`software.${softwareInfo.i18n_title}`) }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-top: 60px;">
                    <div class="col-xl-12 col-lg-12" style="display: flex;  justify-content: center;  align-items: center;">
                            <img class="row_img"  :src="softwareInfo.contentImg" />
                    </div>
                </div>
            </div>
            <div class="container" >
              
            
            </div>
		</section>
         <!-- 解决方案 -->
         <section id="plan_solve" style="padding: 80px 0;background-color: #f9fafc;" v-if="softwareInfo && softwareInfo.i18n_sceneList.length">
            <div class="container" style="background-color: #f9fafc;">
                <h2 class="container_title" >
                    <!-- 客户案例 -->
                     {{  $t("software.customer_case") }}
                </h2>
                <div class="row text_margin margin_bottom">
                    <div class="col-xl-12 col-lg-12 text_margin scene_nav" >
                        <a v-for="(item, index) in softwareInfo.i18n_sceneList" 
                            :key="index" 
                            class="scene_nav_item" 
                            :class="item.type == sceneType ? 'scene_nav_act' : ''"
                            @click="handkeSwitch(item)"
                        >
                            <p> 
                                <!-- {{ item.title }}  -->
                                 {{  $t(`software.${item.title}`) }}
                            </p>
                        </a>
                    </div>
                </div>
                <div  v-for="(item, index) in softwareInfo.i18n_sceneList" :key="index"  >
                    <div class="row text_margin"  v-if="item.type == sceneType">
                        <div class="col-xl-6 col-lg-12 wow fadeInUp" >
                            <img  class="row_img" style="border-radius: 6px;" :src="item.sceneImg" />
                        </div>
                        <div class="col-xl-6 col-lg-12 wow fadeInUp " >
                            <h3 class="scene_title">
                                <!-- {{ item.introduceTitle }} -->
                                {{  $t(`software.${item.introduceTitle}`) }}
                            </h3>
                            <div class="scene_text text_margin_buttom">
                                <p  v-for="(tdItem,tdIndex) in item.introduceList" :key="tdIndex">
                                    <!-- {{ tdItem }} -->
                                    {{  $t(`software.${tdItem}`) }}
                                </p>
                            </div>
                            <h3 class="scene_title">{{  $t(`software.${item.meritTltle}`) }}</h3>
                            <div style="display: flex; margin-bottom: 15px;" v-for="(tdItem,tdIndex) in item.meritList" :key="tdIndex">
                                <div class="icon" style="color: var(--notech-base);font-size: var(--font-size-16); line-height: 1.5;">
										<span class="icon-check"></span>
									</div>
									<div class="text" style="margin-left: 10px; color: var(--notech-black); line-height: 1.5;">
										<p>
                                            <!-- {{ tdItem }} -->
                                            {{  $t(`software.${tdItem}`) }}
                                        </p>
									</div>
                            </div>
                            <div class="scene_img" v-if="item.meritImg">
                                <img  :src="item.meritImg" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script >
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'productApp',
     mixins: [MixinsList],
    components: {

    },
    data () {
        return {          
            softwareInfo: null,  // 信息
            sceneType: "",
        }
    },
    created() {
        this.getList()  // 获取内容
    },
    mounted () {
         // 确定选中的菜单
        $('.current').removeClass('current');  
        $('.product_li').addClass('current');

    
    },
    methods: {
      
        // 获取内容
        async getList() {
            // const { result } = res
            try {
            const software = await loadData('productSoftwareApp', this.lang)
            
           	this.softwareInfo = software[this.$route.query.type]
            if(this.softwareInfo.i18n_sceneList.length) {
                this.sceneType = this.softwareInfo.i18n_sceneList[0].type
            }
            } catch (error) {
                 console.error('[productSoftwareApp] 加载失败:', error)
                 this.softwareInfo = {}
            }
           
        },
        // 应用场景切换
        handkeSwitch(item) {
                this.sceneType = item.type
        },
      
    }
}
</script>
<style scoped>
.main-slider .container {
    padding-top: 150px;
    padding-bottom: 100px;
}

body {
	color: var(--notech-black) !important;
}
.page-header-bg {
    background-color: #0d6fb8; 
}
.page-header__inner{
    text-align: center;
}
.page-header__inner img {
    width: 300px;
}
.main_title {
    width: 100%;
    position: relative;
    z-index: 10;
}
.main_content {
    /* padding: 10px; */
    /* width: 60%; */
    /* height: 100px; */
    border-radius: 10px;
    color: var(--notech-white);
    position: absolute;
    top: -50px;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid #fff;
    background-color: #195269;
    box-shadow: 0px 5px 31px 0 rgba(0, 0, 0, 0.1);
}
.title {
    padding: 10px 80px;
    font-size: var(--font-size-45);
    font-weight: 700;
    text-align: center;
    line-height: 80px;
}

.row_img {
    max-width: 100%;
}

.container_title {
    width: 100%;
    text-align: center;
    /* height: 80px; */
    line-height: 60px;
    font-size: var(--font-size-45);
    color: #232e5e;
}

.text_margin {
    margin-top: 20px;
    color: #666666;
    font-size: var(--font-size-16)
}
.margin_bottom {
    margin-bottom: 60px;
}
.scene_nav{
    width: 100%;
    height: 80px;
    line-height: 80px;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid rgba(0,0,0,.1);
}
.scene_nav_item {
    cursor: pointer;
    width: 33%;
    text-align: center;
    font-weight: 400;
    font-size: var(--font-size-24);
    color: #4e5969;
}
.scene_nav_item:hover p{
    width: 60%;
    margin: 0 auto;
    background: var(--notech-base);
    color: #ffffff;
    transition: all 0.36s;
    border-radius: 6px;
}
.scene_nav_act p{
    width: 60%;
    margin: 0 auto;
    background: var(--notech-base);
    color: #ffffff;
    transition: all 0.36s;
    border-radius: 6px;
}
.scene_title {
    font-size: var(--font-size-24);
    font-weight: bold;
    margin-bottom: 20px;
}
.scene_text {
    
    font-size: var(--font-size-16);
    line-height: 30px;
}
.text_margin_buttom {
    margin-bottom: 50px;
}
</style> 
